import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

interface Props {
  content: any;
}

export const Content = styled.span`
  ${tw`w-full overflow-x-hidden`};

  li {
    ${tw`list-disc my-2 ml-8 mr-4`};
    word-break: break-word;
  }
`;

const FormatHtml: React.FC<Props> = ({ content }) => (
  <Content
    style={{ wordBreak: 'keep-all' }}
    className="format-html"
    dangerouslySetInnerHTML={{
      __html: content
    }}
  />
);

export default FormatHtml;
